<template>
  <div class="col-12 col-md-6 pa-0" :class="question.StyleClass">
    <HomeBaseLabel :question="question" :labelClass="labelClass" />
    <v-text-field
      :id="question?.Vid"
      dense
      outlined
      :hide-details="
        question.HideDetails != null ? question.HideDetails : 'auto'
      "
      validate-on-blur
      :data-uiid="question.InterfaceKey"
      :type="question.AnswerControlAttributeType"
      :placeholder="question.AnswerControlAttributePlaceholder"
      v-model="question.Value"
      v-mask="question.AnswerControlMask"
      :rules="getRules"
      @blur="onBlur"
      @keydown="onKeyDown"
      @error="onError()"
      :inputmode="question.Inputmode"
      :pattern="question.Pattern"
      ref="inputMask"
      :aria-label="question?.Text ?? ''"
    >
      <template v-slot:append>
        <v-icon
          v-if="$refs.inputMask?.valid && question.Value?.length"
          color="green"
          size="20"
          >mdi-check-circle</v-icon
        >
        <v-icon
          v-if="!$refs.inputMask?.valid && $refs.inputMask?.hasMessages"
          color="red"
          size="20"
          >mdi-alert-circle</v-icon
        >
      </template>
    </v-text-field>
  </div>
</template>

<script>
import QuestionValidation from "@/Mixins/Validation/QuestionValidation";
import HomeBaseLabel from "@/components/HomeComponents/HomeBaseComponents/HomeBaseLabel";

export default {
  name: "InputMask",
  components: {
    HomeBaseLabel,
  },
  mixins: [QuestionValidation],
  props: {
    question: {
      type: Object,
      required: true,
    },
    labelClass: {
      type: String,
    },
    isDateMonth: {
      type: Boolean,
      default: false,
    },
    isYear: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onBlur(e) {
      this.$emit("blur", e.target.value);
    },
    onKeyDown(event) {
      const invalidChars = ["e", "E", "+", "-", "."];
      if (event.target.type === "number" && invalidChars.includes(event.key)) {
        event.preventDefault();
      }
    },
    validate() {
      this.$refs.inputMask.validate();
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-size {
  font-size: 20px;
  margin-top: 4px;
}
</style>
